(function contextMenuPlugin(global) {
  "use strict";

  /**
  * Плагин для контекстного меню таблицы.
  *
  * @class WebAccess.components.dataViews.gridPlugins.ContextMenuPlugin
  * @extends WebAccess.Plugin
  * @param {Object} options Настройки контекстного меню
  * @property {string} name Имя плагина
  * @since 5.2.0.1100
  */
  global.ContextMenuPlugin = WA.Plugin.extend({    
    name: 'ContextMenuPlugin',

    // Настройки.
    _contextMenuOptions: {},
    _customMenuClass: null,
    _contextMenu: null,    
    _grid: null,
    _form: null,
  
    init: function (args, opt_form) {
      var me = this;
      this._super();
      if (opt_form) me._form = opt_form;
      if (!args.from) {
        this._customMenuClass = args;
      } else {
        this._contextMenuOptions = args;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.ContextMenuPlugin#register
    * @param {WebAccess.components.dataViews.Grid} grid Таблица
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (grid) {
      var me = this;
      me._grid = grid;

      return {
        'openContextMenu': $.proxy(me._openContextMenu_exported, me)
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открытие контекстного меню.
    * @method WebAccess.components.dataViews.gridPlugins.ContextMenuPlugin#_openContextMenu_exported
    * @private
    * @param {HTMLElement} el Элемент, на котором вызвали контекстное меню
    * @param {Event} ev Событие
    * @since 5.2.0.1100
    */
    _openContextMenu_exported: function (el, ev) {
      var me = this;

      var x = ev.pageX || ev.clientX;
      var y = ev.pageY || ev.clientY;

      if (this._contextMenuOptions.from) {
        me._openLegacyContextMenu(x,y,ev,el);
      } else {
        me._openBaseContextMenu(x,y,ev);
      }

      // Предотвращаем открытие стандратного контекстного меню браузера
      if (ev.preventDefault) ev.preventDefault();
      ev.cancelBubble = true;
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открытие контекстного который был раньше, в pages.js
    * @method WebAccess.components.dataViews.gridPlugins.ContextMenuPlugin#_openLegacyContextMenu
    * @private
    * @param {integer} x-координата
    * @param {integer} y-координата
    * @param {Event} ev Событие.
    * @since 5.2.0.1100
    */
    _openLegacyContextMenu: function (x, y, ev, el) {
      var me = this;
      var jEl = $(el);
      jEl.attr('name', 'MenuIcon');
      ShowContextMenu(jEl, this._contextMenuOptions, (ev ? { 'left': x, 'top': y } : {}));
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открытие контекстного меню с использованием Клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins.ContextMenuPlugin#_openBaseContextMenu
    * @private
    * @param {integer} x-координата
    * @param {integer} y-координата
    * @param {Event} ev Событие.
    * @since 5.2.0.1100
    */
    _openBaseContextMenu: function (x, y, ev) {
      var me = this;
      WA.Init.done(function () {
        me._customMenuClass.setGrid(me._grid);
        me._customMenuClass.setForm(me._form);
        me._contextMenu = new WA.CMP.menus.BaseContextMenu('body', me._customMenuClass.generateItems(ev), {
          'onShow': function () {
            me._removeMenuSelectCssClassAndReturnClickedRow(ev).addClass('menu_select');
          },
          'onHide': function () {
            me._removeMenuSelectCssClassAndReturnClickedRow(ev);
          }
        });
        me._contextMenu.showAt(x, y, ev);
        me._customMenuClass.bindActionsToMenuItems(me._contextMenu, ev, me._grid);
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Удаляет CSS-класс menu_select со всех строк таблицы и возвращаает ту строку, которой кликнули.
    * @method WebAccess.components.dataViews.gridPlugins.ContextMenuPlugin#_removeMenuSelectCssClassAndReturnClickedRow
    * @private
    * @param {Event} ev Событие.
    * @since 5.2.0.1300
    */
    _removeMenuSelectCssClassAndReturnClickedRow: function (ev) {
      var target = ev.target || ev.srcElement;
      var jRow = $(target).parents('div.slick-row');
      jRow.parent().children('.menu_select').removeClass('menu_select');
      return jRow;
    }

  });

})(WA.components.dataViews.gridPlugins);